import { atomFamily, useRecoilState } from 'recoil';
import { devError } from '../utils';
// this is needed to be able to share state between different components
// without constantly having to poll local storage
const localStorageRuntimeCache = atomFamily({
    key: '@zurich/common/hooks/localStorageRuntimeCache',
    default: (key) => {
        // load the initial value from local storage if available, otherwise return null
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            devError(String(error));
            return null;
        }
    },
});
// adapted from https://usehooks.com/useLocalStorage/
export function useLocalStorage(key, initialValue) {
    const [storedValue, setStoredValue] = useRecoilState(localStorageRuntimeCache(key));
    // set a value in local storage and runtime cache
    const setValue = (value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        }
        catch (error) {
            devError(String(error));
        }
    };
    // here we handle the "null" returned from the runtime cache and return the initial value instead
    return [storedValue ?? initialValue, setValue];
}
